<template>
	<div class="container">
		<ul>
			<li
				v-for="(item, index) in props.data"
				:key="index"
				class="c_input_search"
				@click="onClickInputItem(item.country, item.event_pk)"
			>
				<img :src="item.file_path ?? logoImg" alt="기업 아이콘" loading="lazy" />
				<span> [{{ item.event_identifier }}] </span>
				<span>
					{{ item.event_name }}
				</span>
			</li>
		</ul>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { EventSearch } from '@/api/event';
import logoImg from '@/assets/img/bi/bi.svg';
import { useTokenStore } from '@/stores/token';
import { checkLoginDetail } from '@/utils/function/login';

const props = defineProps<{
	data: EventSearch[];
}>();
const emit = defineEmits(['close']);
const router = useRouter();
const tokenStore = useTokenStore();

const onClickInputItem = async (country: string, eventPk: number) => {
	document.body.classList.remove('hidden');
	// 한국주식 - 검색 혹은 기업분석에서의 접근은 7인 구독자에 한정, 다른 곳에서 접근은 꼭 7인 구독이 아니더라도 허용
	// 미국주식 - 7인 구독자만 접근 허용, 페이지 접근 시 router가 막아버림
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}

	if (country === 'KR') {
		router.push({
			path: `/report/kr/${eventPk}`,
			query: { tab: '개요' },
		});
	} else {
		if (country === 'USA') {
			router.push({
				path: `/report/usa/${eventPk}`,
				query: { tab: '개요' },
			});
		} else {
			router.push({
				path: `/report/jpn/${eventPk}`,
				query: { tab: '개요' },
			});
		}
	}

	emit('close');
};
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	width: 100%;
	.c_input_search {
		display: flex;
		gap: 0.4rem;
		align-items: center;
		img {
			width: 2.4rem;
			height: 2.4rem;
			border-radius: 0.9rem;
		}
	}
}
</style>
